import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";

const MOB_Incoming = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [selectStatus, setSelectStatus] = useState('');
    const [selectKeyword, setSelectKeyword] = useState('');
    const [selectStartDate, setSelectStartDate] = useState(appStore.YYYY_MM_01());
    const [selectEndDate, setSelectEndDate] = useState(appStore.YYYY_MM_DD());
    const [originRows, setOriginRows] = useState([]);
    const [incomingList, setIncomingList] = useState([]);

    useEffect(() => {
        appStore.setLoading(true);

        // 권한 설정은 주석 처리된 상태
        const fromSearch = location.state?.fromSearch;
        if (fromSearch) {
            setSelectStartDate(fromSearch.selectStartDate || '');
            setSelectEndDate(fromSearch.selectEndDate || '');
            setSelectStatus(fromSearch.selectStatus || '');
            setSelectKeyword(fromSearch.selectKeyword || '');
        }

        setTimeout(() => { // 초기 화면인 경우 늦게 표시 됨.
            const accessList = JSON.parse(localStorage.getItem("nav"));
            if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
                setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
                setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
                setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
                setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
                setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
                setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            } else {
                Swal.fire({
                    title: '<p style="color:red">접근 권한 오류</p>',
                    text: '화면에 접근 권한이 없습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((value) => {
                    return navigate(-1);
                });
            }
            appStore.setLoading(false);
        }, 800);

    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSearch();
        }
    }, [MenuID]);

    const handleSearch = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);

        axios.get('/api/p/Incoming/List',
            {
                params: {
                    search: selectKeyword,
                    status: selectStatus
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            var array = response.data.map((item) => ({
                id: item.incoming_id,
                incoming_number: item.incoming_number,
                incoming_status: item.incoming_status,
                incoming_status_name: item.incoming_status_name,
                incoming_purchase_number: item.incoming_purchase_number,
                incoming_purchase_name: item.incoming_purchase_name,
                incoming_partner_name: item.incoming_partner_name,
                recent_update_user_name: item.update_user_name || item.reg_user_name,
                recent_update_datetime: Moment(item.update_datetime || item.reg_datetime).format('YYYY-MM-DD HH:mm:ss')
            }));
            setOriginRows(response.data);
            setIncomingList([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });
    };

    const handleRowClick = (incoming_id) => {
        navigate(`/m/incoming_detail/${incoming_id}`, {
            state: {
                fromSearch: {
                    originRows: originRows.filter((originRows) => originRows.incoming_id === incoming_id),
                    selectStartDate: selectStartDate,
                    selectEndDate: selectEndDate,
                    selectStatus: selectStatus,
                    selectKeyword: selectKeyword
                }
            }
        });
    };

    return (
        <div style={{ width: '100%', display: String(MenuID) === String(0) || String(MenuName) === String('') ? 'hidden' : 'block' }}>
            <div className="M_menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div style={{ float: 'right' }}>
                        <Button
                            onClick={handleSearch}
                            className="M_btn-p"
                            sx={{
                                m: 1,
                                fontSize: 15,
                                color: "white",
                                borderColor: "#3D63AE",
                                backgroundColor: "#3D63AE",
                                ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                            }}
                            variant="outlined">
                            조회
                        </Button>
                    </div>
                </div>
            </div>

            <div className="M_contents">
                <div style={{ overflow: 'hidden' }}>
                    <div className="M_menu-keyword-sub-keyword" style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        }}>
                        <input
                            type="date"
                            value={selectStartDate}
                            onChange={(e) => setSelectStartDate(e.target.value)}
                            style={{ flex: 1 }}
                        />
                        <span style={{ color: '#999' }}>~</span>
                        <input
                            type="date"
                            value={selectEndDate}
                            onChange={(e) => setSelectEndDate(e.target.value)}
                            style={{ flex: 1 }}
                        />
                        </div>

                    <div className="M_menu-keyword-sub-keyword" style={{ float: 'left', width: '120px', paddingBottom: '10px' }}>
                        <select value={selectStatus} onChange={(e) => setSelectStatus(e.target.value)}>
                        <option value="">전체</option>
                        <option value="S">입고완료</option>
                        <option value="D">입고취소</option>
                        </select>
                    </div>
                    <div className="M_menu-keyword-sub-keyword" style={{ float: 'right', paddingLeft: '10px', width: 'calc(100% - 120px)' }}>
                        <input
                        type="text"
                        placeholder="검색"
                        value={selectKeyword}
                        onChange={(e) => setSelectKeyword(e.target.value)}
                        style={{ width: '100%' }}
                        />
                    </div>
                </div>

                <div>
                    {incomingList.length === 0 ? (
                        <p style={{ textAlign: 'center', color: '#aaa' }}>입고정보가 없습니다.</p>
                    ) : (
                        incomingList.map((incoming) => (
                        <div
                            key={incoming.id}
                            onClick={() => handleRowClick(incoming.id)}
                            style={{
                            backgroundColor: '#fff',
                            borderBottom: '1px solid #eee',
                            padding: '7px 8px',
                            fontSize: '14px'
                            }}
                        >
                            {/* ✅ 1줄: 입고번호 + 입고명 */}
                            <div style={{
                            fontWeight: 'bold',
                            fontSize: '16px',
                            color: '#222',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                            }}>
                            [{incoming.incoming_number}] {incoming.incoming_purchase_name}
                            </div>

                            {/* ✅ 2줄: 거래처명 */}
                            <div style={{
                            fontSize: '15px',
                            color: '#444',
                            marginTop: '4px',  // 간격 통일
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                            }}>
                            {incoming.incoming_partner_name}
                            </div>

                            {/* ✅ 3줄: 수정자 | 일시 + 입고상태 */}
                            <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: '4px'  // 간격 통일
                            }}>
                            <div style={{ fontSize: '13px', color: '#888' }}>
                                {incoming.recent_update_user_name} | {incoming.recent_update_datetime}
                            </div>
                            <div style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: incoming.incoming_status === 'D' ? '#ff4d4f' : '#3D63AE',
                                whiteSpace: 'nowrap',
                                marginLeft: '10px'
                            }}>
                                {incoming.incoming_status_name}
                            </div>
                            </div>
                        </div>
                        ))
                    )}
                    </div>
            </div>
        </div>
    );
};

export default MOB_Incoming;